import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const NoResults = ({clang}) => {
    return (
        <div className="results__no-results--in-cards">
            <p className="results__no-results--in-cards-desc">{lang[clang].results.no_results}</p>
        </div>
    );
};

NoResults.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(NoResults);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/NoResults.js